import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ThemeContext } from '../theme/themeContext';
import { Bars3Icon } from '@heroicons/react/24/solid';

const Header = () => {
  const { t, i18n } = useTranslation();
  const { dark, setDark } = useContext(ThemeContext);

  const toggleLang = () => i18n.changeLanguage(i18n.language === 'es' ? 'en' : 'es');

  return (
    <header className="fixed w-full z-40 bg-white/60 dark:bg-black/60 backdrop-blur-md">
      <div className="max-w-6xl mx-auto flex items-center justify-between p-3">
        <div className="flex items-center gap-3">
          <div className="font-poppins text-xl text-primary">Yerika Marley</div>
          <nav className="hidden md:flex gap-4 text-sm">
            <a href="#home" className="hover:scale-105 transition">{t('nav.home')}</a>
            <a href="#about" className="hover:scale-105 transition">{t('nav.about')}</a>
            <a href="#skills" className="hover:scale-105 transition">{t('nav.skills')}</a>
            <a href="#experience" className="hover:scale-105 transition">{t('nav.experience')}</a>
            <a href="#projects" className="hover:scale-105 transition">{t('nav.projects')}</a>
          </nav>
        </div>

        <div className="flex items-center gap-3">
          <button
            aria-label="toggle-lang"
            onClick={toggleLang}
            className="px-2 py-1 rounded-md border"
          >
            EN/ES
          </button>
          <button
            aria-label="toggle-theme"
            onClick={() => setDark(!dark)}
            className="px-2 py-1 rounded-md border"
          >
            {dark ? '🌙' : '☀️'}
          </button>
          <button className="hidden p-2 rounded-md border">
  <Bars3Icon className="w-5 h-5" />
</button>

        </div>
      </div>
    </header>
  );
};

export default Header;
